<template>
  <el-dialog
    title="在线帮助"
    :visible.sync="dialogVisible"
    width="520px"
    append-to-body
    class="help-dialog"
    @open="onOpen"
  >
    <div class="help-section">
      <h4>平台说明</h4>
      <p>
        智慧燃气综合管理平台用于燃气仪表数据采集、终端监控、告警处置、报表分析与系统运维。
        左侧菜单按业务模块划分，点击即可进入对应功能页。
      </p>
    </div>
    <div class="help-section">
      <h4>常用操作</h4>
      <ul>
        <li>首页 <strong>概览</strong>：查看终端在线率、告警概况等汇总数据。</li>
        <li><strong>设备 / 终端</strong>：维护设备档案，查看终端实时状态与通信报文。</li>
        <li><strong>告警管理</strong>：处理实时告警，在告警设置中配置规则阈值。</li>
        <li><strong>报表管理</strong>：按日期查询流量计日报并导出。</li>
        <li><strong>系统设置</strong>：基础参数、数据库备份与操作日志。</li>
      </ul>
    </div>
    <div class="help-section">
      <h4>快捷入口</h4>
      <div class="help-links">
        <el-button
          v-for="link in quickLinks"
          :key="link.path"
          size="small"
          @click="go(link.path)"
        >
          {{ link.label }}
        </el-button>
      </div>
    </div>
    <div class="help-section help-contact">
      <h4>联系支持</h4>
      <p>上海晟颢信息科技有限公司</p>
      <p class="muted">如遇登录失败、数据异常或权限问题，请联系系统管理员，并提供操作时间与页面路径。</p>
      <p class="muted">技术支持热线：<strong>400-888-6688</strong>（工作日 9:00–18:00）</p>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'HeaderHelpDialog',
  props: {
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      quickLinks: [
        { label: '首页概览', path: '/home/overview' },
        { label: '设备监控', path: '/device/monitor' },
        { label: '实时告警', path: '/alarm/realtime' },
        { label: '日报表', path: '/report/daily' },
        { label: '用户列表', path: '/user/list' }
      ]
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      }
    }
  },
  methods: {
    onOpen() {},
    go(path) {
      this.dialogVisible = false
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style scoped>
.help-section {
  margin-bottom: 20px;
}
.help-section:last-child {
  margin-bottom: 0;
}
.help-section h4 {
  margin: 0 0 8px;
  font-size: 14px;
  color: #1d2129;
}
.help-section p,
.help-section li {
  margin: 0 0 6px;
  font-size: 13px;
  line-height: 1.6;
  color: #4e5969;
}
.help-section ul {
  margin: 0;
  padding-left: 18px;
}
.help-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.help-contact .muted {
  color: #86909c;
  font-size: 12px;
}
</style>
